import { request } from "../utils/request"


export enum RecordType {
    Check = 'Check', // 人工拍照打卡
    Maintain = 'Maintain', // 视频定时拍照
    Camera = 'Camera',
    Unknow = 'Unknow', // 其他未知
}


export const deleteRecord = (data: { id: number }): Promise<any> => {
    return request.post('/record/maintain/delete', data)
}


export const updateRecord = (data: { id: number, proj: number | null, category: string, status: string, point?: number | null, stamp?: string | null }): Promise<any> => {
    return request.post('/record/maintain/update', data)
}

export const createRecord = (data: { proj: number | null, category: string, status: string, point?: number | null, stamp?: string | null }): Promise<any> => {
    return request.post('/record/maintain', data)
}

export const getRecords = (params: { page: number, limit: number, type?: RecordType }): Promise<any> => {
    return request.get('/record', { params })
}


